import styled from 'styled-components';

import { Button as ButtonComponent } from '@xing-com/button';

export const UnfollowButton = styled(ButtonComponent)`
  padding-inline: 0;
`;
